module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "svg-sprite.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }